<template>
  <div class="welcome-set-menu">
    <div
      v-for="day in menuDays"
      :key="day.date"
      class="welcome-set-menu__day-info"
    >
      <p
        class="welcome-set-menu__date"
      >
        {{ day.prettyDate }}
      </p>
      <div
        class="welcome-set-menu__packs"
      >
        <MenuPack
          v-for="pack in day.visiblePacks"
          :key="pack.id"
          :pack="pack"
        />
        <EmptyPack v-if="isEmptyPackDisplayed(day.visiblePacks)" />
      </div>
    </div>
  </div>
</template>

<script>
import { dayjs } from '@/services/dayjs'
import MenuPack from '@/components/newOrderV4/OrderMenu/MenuPack'
import EmptyPack from '@/components/newOrderV4/OrderMenu/EmptyPack'

export default {
  name: 'WelcomeSetMenu',

  components: {
    MenuPack,
    EmptyPack,
  },

  props: {
    menu: {
      type: Object,
      required: true,
    },

    visibleDays: {
      type: Number,
      default: 2,
    },
  },

  computed: {
    menuDays () {
      const days = []
      this.menu.days.forEach((day) => {
        const date = dayjs(day.date, 'YYYY-MM-DD')
        const visiblePacks = []
        day.items.forEach((item) => {
          let pack = this.menu?.packs.find((pack) => pack.id === item.major[0])
          if (!pack) {
            const customization = this.menu?.customization || []
            const custom = customization.find((custom) => custom.mealDate === day.date && custom.mealNumber === item.position)
            if (!custom || custom.remove) {
              return
            }
            pack = this.menu?.packs.find((pack) => pack.id === custom.packId)
          }
          visiblePacks.push({
            ...pack,
            title: item.title,
          })
        })
        days.push({
          date: day.date,
          prettyDate: date.format('dddd, D MMMM'),
          items: day.items,
          visiblePacks,
        })
      })
      days.length = this.visibleDays
      return days
    },
  },

  methods: {
    isEmptyPackDisplayed (packs) {
      return packs.length % 2
    },
  },
}
</script>

<style lang="scss">
.welcome-set-menu {
  &__date {
    color: #0D0D0D;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.38px;
    margin: 32px 0 16px;

    &::first-letter {
      text-transform: capitalize;
    }
  }

  &__packs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
}
</style>
